import { makeMap } from '@/shared/lib/utils/default/map'
import { getTheme } from '@/shared/lib/model'

export function setMeta({
    title,
    faviconUrl,
}: {
    title?: string
    faviconUrl?: string
}) {
    setThemeBackground()
    setTitle(title)

    if (faviconUrl) {
        setFavicon(faviconUrl)
    }
}

function setThemeBackground() {
    const theme = getTheme()
    const color = theme === 'dark' ? '#22272a' : '#fff'
    const msAppMeta = document.querySelector(
        'meta[name="msapplication-navbutton-color"]'
    )
    msAppMeta?.setAttribute('content', color)
}

function setTitle(merchantName?: string) {
    const titleMeta = document.getElementsByTagName('title')[0]
    if (titleMeta && merchantName) {
        titleMeta.innerHTML = `${merchantName} — страница оплаты`
    }
}

const favImagesMap = makeMap({
    '32x32': 'favicon-32',
    '48x48': 'favicon-48',
    '57x57': 'favicon-57',
    '64x64': 'favicon-64',
    '96x96': 'favicon-96',
    '144x144': 'favicon-144',
})
const favAppleImagesMap = makeMap({
    '76x76': 'apple-touch-icon-76',
    '120x120': 'apple-touch-icon-120',
    '144x144': 'favicon-144',
    '152x152': 'apple-touch-icon-76@2x',
    '180x180': 'apple-touch-icon-180',
})

function setFavicon(faviconUrl: string) {
    const favicons = document.head.querySelectorAll('link')
    const merchantDirectory = `${faviconUrl}/`
    let favImageName = ''
    favicons.forEach(tag => {
        if (['dns-prefetch', 'preconnect'].includes(tag.rel)) return

        const rel = tag.getAttribute('rel')
        const sizes = tag.getAttribute('sizes')

        if (rel === 'shortcut icon') {
            favImageName = 'favicon-16'
        }

        if (rel === 'icon') {
            favImageName = sizes ? favImagesMap.get(sizes)! : 'favicon'
        }

        if (rel === 'apple-touch-icon-precomposed') {
            favImageName = 'favicon-72'
        }

        if (rel === 'apple-touch-icon') {
            favImageName = sizes
                ? favAppleImagesMap.get(sizes)!
                : 'apple-touch-icon-1024'
        }

        const href = `${merchantDirectory}${favImageName}.png`

        tag.setAttribute('href', href)
    })
}
